import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { FilterService, SortEvent } from 'primeng/api';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { Table, TableFilterEvent } from 'primeng/table';
import { map } from 'rxjs';
import { LabelValuePair, ScrBaseComponent } from 'src/app/components/base.component';
import { SuspiciousActivityList, SuspiciousActvityVO, UpdateSuspiciousActivityRequest } from 'src/app/models/shortcodes.model';
import { TableColumn } from 'src/app/models/table-columns';
import { Aggregator, ConfigService, ScrBaseService, ShortCodesService, UserService } from 'src/app/services';
import { handleEnterKeyPress } from 'src/app/shared/common-events';
import { ShortCodesRole } from '../../../../models/constants';

@Component({
  selector: 'app-carrier-reported-activities',
  templateUrl: './carrier-reported-activities.component.html',
  styleUrls: ['./carrier-reported-activities.component.scss']
})
export class CarrierReportedActivitiesComponent extends ScrBaseComponent implements OnInit {

  @ViewChild('tt', { static: false }) tt!: Table;
  @ViewChild('globalSearch', { static: false }) globalSearch!: ElementRef;
  shortCodeValue!: string;
  shortCodeDisplay?: string;
  shortCodeStatus?: string;
  apiMessage?: string;
  suspiciousActivityList?: SuspiciousActivityList[];
  listToShow?: SuspiciousActvityVO[] = [];
  searchShortCodeValue = '';
  showUpdateActivityPanel = false;
  showReportByColumn = false;
  selectedRowToUpdate = new SuspiciousActivityList();
  statusOptions = [
    { label: 'Open', value: 'Open' }, { label: 'Cancelled', value: 'Cancelled' }
  ];
  model = { status: '', comment: '', sharedShortCode: false };
  public shortCodeSearchInput?: string;
  shortCodeToNumeric = ScrBaseService.shortCodeToNumeric;
  filtersVisible = false;
  filterKeys: string[] = [];
  allActivityType: LabelValuePair[] = [];
  allStatus: LabelValuePair[] = this.statusOptions;
  allLeesee: LabelValuePair[] = [];

  comment = new FormControl();
  public aggregators: Aggregator[] = [];
  loggedInUserAccountId =0;
  public tableColumn: TableColumn[] = [
    { field: 'lastUpdate', width: '10', sort: true },
    { field: 'shortCode', width: '10', sort: true },
    { field: 'activityId', width: '10', sort: true },
    { field: 'leesee', width: '10', sort: true },
    { field: 'activityType', width: '10', sort: false },
    { field: 'shared', width: '10', sort: true }
  ];

  constructor(private filterService: FilterService, private shortCodesService: ShortCodesService, private userService: UserService, private configService: ConfigService) {
    super();
  }

  ngOnInit(): void {
    this.localizeTableColumns(this.tableColumn);
    const customFilterName = 'multi-select-in';
    this.filterService.register(customFilterName, (value: string[], filter: string[]): boolean => {
      if (filter == null || filter.length == 0) {
        return true;
      }

      return value.some((r: string) => filter.includes(r));
    });
    this.configService.getAggregators().subscribe(res => {
      this.aggregators = res.filter(aggregator => aggregator.aggregatorId != 9999);
    });
    this.fetchSuspiciousActivityList();
    this.addReportByColumn();
    this.localizeTableColumns(this.tableColumn);

    if (history.state.message) {
      this.displaySuccess(history.state.message, true);
    }
    this.configService.getSuspiciousActivityConfig().subscribe(res => {
      if (res.activityTypes) {
        res.activityTypes.forEach((val) => {
          this.allActivityType.push({label: val, value: val});
          this.allActivityType.sort((a, b) => a.label.localeCompare(b.label));
        });
      }
    });
  }

  fetchSuspiciousActivityList(expanded?: number): void {

    this.shortCodesService
      .getSuspiciousActivities()
      .pipe(
        map((activities) => {
          activities.activities?.sort(
            (a: SuspiciousActivityList, b: SuspiciousActivityList): number => {
              let aDate = 0;
              let bDate = 0;
              if (
                a.statuses &&
                b.statuses &&
                a.statuses[0].createTime &&
                b.statuses[0].createTime
              ) {
                aDate = new Date(a.statuses[0].createTime).getTime();
                bDate = new Date(b.statuses[0].createTime).getTime();
              }
              return aDate - bDate > 0 ? -1 : 1;
            }
          );
          return activities.activities;
        })
      )
      .subscribe((data) => {
        this.suspiciousActivityList = data;
        if (this.suspiciousActivityList) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.suspiciousActivityList?.forEach((status:any) => {
            status['status'] = status.statuses[0].status;
            if (!this.allLeesee.some(leesee => leesee.value === status.lesseeCompany)) {
              this.allLeesee.push({label: status.lesseeCompany, value: status.lesseeCompany});
            }
          });
          this.allLeesee.sort((a, b) => (a.label.toLowerCase() < b.label.toLowerCase()) ?
            -1 : (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : 0);
        }
        
        // optionally, re-expanded the previously expanded row.
        if (this.tt && expanded) {
          this.tt.expandedRowKeys[expanded] = true;
        }
        this.fetchDetailsFromLocalStorageAndUpdate();
      });
  }

  /**
  * Override the sort to handle customizations.  
  * @param event - sort event describing what the user clicked.
  */
  customSort(event: SortEvent) {

    if (!event.data) {
      return;
    }

    const data = event.data as SuspiciousActivityList[];
    data.sort((a, b) => {
      let rv = 0;
      if (event.field === 'shortCode') {
        if (a.shortCode && b.shortCode) {
          rv = a.shortCode - b.shortCode;
        }
      }
      else if (event.field === 'activityId') {
        if (a.activityId && b.activityId) {
          rv = a.activityId - b.activityId;
        }
      }
      else if (event.field === 'lastUpdate') {
        if (a.statuses && b.statuses && a.statuses[0].createTime && b.statuses[0].createTime) {
          rv = new Date(b.statuses[0].createTime).getTime() - new Date(a.statuses[0].createTime).getTime() > 0 ? -1 : 1;
        }
      }
      else if (event.field === 'leesee') {
        if (a.lesseeCompany && b.lesseeCompany) {
          rv = a.lesseeCompany.localeCompare(b.lesseeCompany);
        }
      } else if (event.field === 'activityType') {
        if (a.activityTypes && b.activityTypes) {
          rv = a.activityTypes[0].localeCompare(b.activityTypes[0]);
        }
      } else if (event.field === 'shared') {
        rv = (a.sharedShortCode === b.sharedShortCode) ? 0 : a.sharedShortCode ? -1 : 1;
      } else if (event.field === 'createdByCompany') {
        if (a.createdByCompany && b.createdByCompany) {
          rv = a.createdByCompany.localeCompare(b.createdByCompany);
        }
      }
      if (event.order) {
        rv *= event.order;
      }

      if (rv === 0) {
        if (a.statuses && b.statuses && a.statuses[0].createTime && b.statuses[0].createTime) {
          rv = new Date(a.statuses[0].createTime).getTime() - new Date(b.statuses[0].createTime).getTime() > 0 ? -1 : 1;
        }
      }
      return rv;
    });
  }

  addReportByColumn() {
    this.userService.getUserProfile().subscribe((data) => {
      this.loggedInUserAccountId = data.user.accountId;
        this.showReportByColumn = false;
        if(data.user.roleList.includes(ShortCodesRole.CTIAAdmin)) {
        this.showReportByColumn = true;
        this.tableColumn.push({ field: 'createdByCompany', header: 'Reported By', width: '10', sort: true });
      }
    });
  }

  findAggregatorName(id: number) {
    const selectedAggregator = this.aggregators.find((aggregator: Aggregator) => aggregator.aggregatorId === id);
    return selectedAggregator?.name;
  }

  updateActivity(row: SuspiciousActivityList) {
    this.selectedRowToUpdate = row;
    this.model.status = 'Open';
    this.model.sharedShortCode = row.sharedShortCode ? true : false;
    if(this.model.comment){
      this.model.comment = '';
    }
    this.showUpdateActivityPanel = true;
  }

  handleEnter(event: Event) {
    handleEnterKeyPress(event);
  }

  updateSuspiciousActivity(form: NgForm) {
    if (form.valid) {
      const req = new UpdateSuspiciousActivityRequest();
      req.status = this.model.status;
      req.comment = this.model.comment;
      req.sharedShortCode = this.model.sharedShortCode;
      this.observe(this.shortCodesService.updateSuspiciousActivity(req, Number(this.selectedRowToUpdate.activityId)), {
        onSuccess: (res) => {
          this.showUpdateActivityPanel = false;
          let message = '';
          if (res.messages && res.messages.length > 0) {
            message = res.messages[0].message;
          }
          this.displaySuccess(message, true);
          this.model.sharedShortCode = false;
          this.fetchSuspiciousActivityList(this.selectedRowToUpdate.activityId);
        },
        onError: (error: HttpErrorResponse) => {
          this.displayErrorMessage(error.error);
        }
      });
    }
  }

  fetchDetailsFromLocalStorageAndUpdate() {
    if (this.shortCodeSearchInput) {
      this.onSlide();
    }
  }

  cancel(form: NgForm) {
    form.resetForm();
    this.showUpdateActivityPanel = false;
    setTimeout(() => this.fetchDetailsFromLocalStorageAndUpdate());
  }

  tableFiltered(e: TableFilterEvent) {
    
    this.filterKeys = [];
    if (e.filters) {
      Object.keys(e.filters).forEach(key => {
        if (e.filters && e.filters[key]?.value !== null &&
          (e.filters[key]?.value?.length && e.filters[key]?.value?.length !== 0)) {
          this.filterKeys.push(key);
         }
      });
    }
  }

  toggleFilter(): void {
    this.filtersVisible = !this.filtersVisible;
  }

  clearFilter() {
    this.tt.clearFilterValues();
    this.tt.filterGlobal(undefined, 'contains');
  }

  onChangeSharedCheckbox(event: CheckboxChangeEvent) {
    this.model.sharedShortCode = event.checked;
  }

  onSlide(): void {
    this.tt.globalFilterFields?.pop();
    this.tt.globalFilterFields?.push('shortCode');
    this.tt.filterGlobal(this.shortCodeSearchInput, 'contains');
  }
}

